<template>
	<div class="login-register-bg" :style="{height:height}">

		<div class="login-box">
			<div class="up">
				<p class="big-title">找回密码</p>
				<div class="step-list">
					<div class="step-item">
						<img class="step-image" src="../../assets/images/step1-active.png" alt="">
						<p>验证身份</p>
					</div>
					<div class="separator"></div>
					<div class="step-item">
						<img class="step-image"  v-if="current_step>1" src="../../assets/images/step2-active.png" alt="">
						<img class="step-image"  v-else src="../../assets/images/step2.png" alt="">
						<p>重置密码</p>
					</div>
					<div class="separator"></div>
					<div class="step-item">
						<img class="step-image" v-if="current_step>2" src="../../assets/images/step3-active.png" alt="">
						<img class="step-image" v-else src="../../assets/images/step3.png" alt="">
						<p>设置成功</p>
					</div>
				</div>
			</div>

			<div class="bottom">
				<div v-show="current_step===1">
					<div class="form">
						<div class="form-group">
							<div class="form-label">手机号</div>
							<div class="form-control">
								<input type="text" class="input" placeholder="请输入手机号" v-model="form_data1.mobile" />
							</div>
						</div>

						<div class="form-group">
							<div class="form-label">验证码</div>
							<div class="form-code">
								<input type="text" class="input" placeholder="请输入手机验证码" v-model="form_data1.code" />
								<sms-code class="sms-code" :mobile="form_data1.mobile"></sms-code>
							</div>
						</div>
						<!-- <div class="form-group">
							<div class="form-label">验证码</div>
							<div class="form-control">
								<input type="text" class="input" placeholder="请输入手机验证码" v-model="form_data1.code" />
								<sms-code class="btn-code" :mobile="form_data1.mobile"></sms-code>
							</div>
						</div> -->

						<div class="btn-submit" @click="finish1">下一步</div>
						<p class="b-text">返回 <a @click="go2login" class="btn-login">登录</a></p>
					</div>
				</div>
				<div v-show="current_step===2">
					<div class="form">
						<div class="form-group">
							<div class="form-label">设置新密码</div>
							<div class="form-control">
								<input type="text" class="input" placeholder="请输入新密码" v-model="form_data2.password" />
							</div>
						</div>

						<div class="form-group">
							<div class="form-label">确认新密码</div>
							<div class="form-control">
								<input type="text" class="input" placeholder="请再次输入密码" v-model="form_data2.confirm_password" />
							</div>
						</div>

						<div class="btn-submit" @click="finish2">下一步</div>
					</div>
				</div>
				<div v-show="current_step===3">
					<div class="ok-wrap">
						<img src="../../assets/images/icon-find-success.png" alt="" class="success">
						<div class="text">
							<p class="up-text">
								密码重设成功，请登录您的账号
							</p>
							<p class="bottom-text">请牢记您的账户密码 页面正在跳转中......或 <a @click="go2login" class="btn-login">点击登录</a></p>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import SmsCode from "@/components/SmsCode.vue";
	import {
		CheckSms,
		ResetPassword
	} from "@/api/index.js"
	import localStorage from '@/utils/localStorage.js'
	export default {
		name: "FindPwd",
		components: {
			SmsCode
		},
		data() {
			return {
				is_click: false,
				height: '600px',
				current_step: 1,
				form_data1: {
					mobile: '',
					code: ''
				},
				form_data2: {
					password: '',
					confirm_password: ''
				},

			};
		},
		computed: {
		},
		created() {
			this.height = (window.innerHeight - 78) + 'px'
		},
		methods: {
			go2login() {
				this.$router.replace({name: 'Login'})
			},
			validate_captcha() {
				if(this.form_data.captcha_code.length === 0) {
					this.$layer.msg(`请输入验证码`)
					return
				}
				if(this.captcha_code != this.form_data.captcha_code) {
					this.$layer.msg(`验证码错误`)
					return
				}
				this.form_data.captcha_code = ''
			},
			finish1() {
				if(!this.form_data1.code) {
					this.$layer.msg(`请输入手机验证码`)
					return
				}
				CheckSms({
					...this.form_data1,
					scene: 'common'
				}).then(() => {
					this.current_step = 2
				}).catch((res)=>{
					this.$layer.msg(res.msg)
				})

			},
			finish2() {
				if(!this.form_data2.password) {
					this.$layer.msg("请输入密码")
					return
				}
				if(!this.form_data2.confirm_password) {
					this.$layer.msg("请输入确认密码")
					return
				}
				if(this.form_data2.password != this.form_data2.confirm_password) {
					this.$layer.msg("两次密码不一致")
					return
				}
				ResetPassword({
					...this.form_data1,
					...this.form_data2,
				}).then(() => {
					this.current_step = 3
					setTimeout(() => {
						this.$router.replace({name: 'Login'})
					}, 3000)
				}).catch((res)=>{
					this.$layer.msg(res.msg)
				})
			},

		},
	};
</script>

<style scoped lang="scss">
	.login-register-bg {
		background: #F9F9F9;
		padding-top: 100px;
		.login-box {
			width: 1200px;
			height: 600px;
			margin: 0 auto;
			background: #ffffff;

			.up {
				height: 210px;
				border-bottom: 1px solid #E2E2E2;
				.big-title {
					padding: 50px 0 40px;
					font-size: 20px;
					color: #2C2E30;
					font-weight: bold;
					text-align: center;
				}

				.step-list {
					display: flex;
					justify-content: center;
					align-items: center;
					.separator {
						margin-top: -22px;
						width: 120px;
						height: 2px;
						background: #E2E2E2;
						box-sizing: border-box;
					}
					.step-item {
						display: flex;
						flex-wrap: wrap;
						justify-content: center;
						width: 60px;
						.step-image {
							width: 35px;
							height: 35px;
						}
						p {
							margin-top: 8px;
						}
					}
				}
			}


			.bottom {
				.form {
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
					width: 360px;
					margin: 30px auto 0;
					.form-group {
						width: 280px;
						margin-top: 20px;
						.form-label {
							font-size: 16px;
							color: #1A1A1A;
						}
						.form-control {
							position: relative;
							.input {
								width: 100%;
								height: 40px;
								line-height: 40px;
								border:none;
								border-bottom: 1px solid #F0F0F0;
								outline: none;
								&.input-medium {
									width: 160px;
								}
							}

							.btn-code {
								position: absolute;
								top: 12px;
								right: 0;
							}
						}
						.form-code{
							display:flex;
							justify-content:space-between;
							align-items:center;
							border-bottom: 1px solid #F0F0F0;
							.input {
								width: 100%;
								height: 40px;
								line-height: 40px;
								border:none;
								outline: none;
								&.input-medium {
									width: 160px;
								}
							}
							.sms-code{
								margin-top:0;
							}
						}
					}

					.btn-submit {
						margin: 50px 0 25px;
						width: 280px;
						height: 45px;
						line-height: 45px;
						text-align: center;
						background: #FA3D5A;
						color: white;
						border-radius: 6px;
						cursor: pointer;
					}
					.b-text {
						width: 100%;
						color: #666;
						font-size: 14px;
						text-align: center;
						.btn-login {
							color: #303234;
						}
					}
				}

				.ok-wrap {
					display: flex;
					justify-content: center;
					align-items: center;
					margin-top: 90px;
					.success {
						width: 55px;
						height: 55px;
						margin-right: 20px;
					}
					.text {
						font-weight: bold;
						.up-text {
							color: #1A1A1A;
							font-size: 16px;
						}

						.bottom-text {
							margin-top: 10px;
							color: #999999;
							font-size: 12px;
							.btn-login {
								color: #FA3D5A;
							}
						}
					}
				}
			}
		}
	}

</style>
